import { createContext, use } from 'react';
import type { AugmentedAccount, AugmentedUser } from './types';

type Auth = {
  account: AugmentedAccount;
  user: AugmentedUser;
};

const AuthContext = createContext<Auth | null>(null);

type AuthProviderProps = { children: React.ReactNode; auth: Auth };

export function AuthProvider({ children, auth }: AuthProviderProps) {
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = use(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
